<template>
    <b-modal
        :active="active"
        @close="close()">
        <form @submit.prevent="save()">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">
                        <template v-if="filterType != 'tag'">
                            Редактирование ролей
                        </template>
                        <template v-else>
                            Редактирование тэгов
                        </template>
                    </p>
                </header>
                <section class="modal-card-body">

                    <div class="table-container">
                        <table class="table is-fullwidth">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th>Название</th>
                                    <th v-if="filterType != 'tag'">Привилегии</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="role in roles"
                                    :key="role.id">
                                    <td>
                                        <b-checkbox
                                            v-model="checked"
                                            :native-value="{
                                                id: role.id
                                            }">
                                        </b-checkbox>
                                    </td>
                                    <td style="width: 0">
                                        <span class="icon" v-if="role.is_hidden">
                                            <b-tooltip
                                                animated
                                                type="is-warning"
                                                position="is-right"
                                                label="Роль скрыта">
                                                <i class="mdi mdi-24px mdi-eye-off-outline has-text-warning"></i>
                                            </b-tooltip>
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            {{ role.title || role.name }}
                                        </span>
                                    </td>
                                    <td v-if="filterType != 'tag'">
                                        <div class="tags"
                                            v-if="role.permissions.length > 0">
                                            <div
                                                v-for="p in role.permissions"
                                                :key="p.id"
                                                :class="{
                                                    'is-primary': p.name == 'manage roles'
                                                }"
                                                class="tag">
                                                {{ p.name }}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <b-pagination
                        @change="fetch"
                        order="is-centered"
                        :total="pagination.total"
                        :current.sync="pagination.current"
                        :per-page="pagination.perPage">
                    </b-pagination>

                </section>
                <footer class="modal-card-foot">
                    <button
                        @click="close()"
                        class="button"
                        type="button">
                        Закрыть
                    </button>
                    <button
                        class="button is-primary">
                        Сохранить
                    </button>
                </footer>
            </div>
        </form>
    </b-modal>
</template>

<script>
import BaseModal from "../BaseModal";
import HasUser from "../../../mixins/HasUser";
import HasPagination from "../../../mixins/HasPagination";

export default BaseModal.extend({
  mixins: [HasUser, HasPagination],
  props: {
    defaultType: {
      type: String,
      default: "any"
    }
  },
  data() {
    return {
      filterType: this.defaultType,
      roles: {},
      checked: []
    };
  },
  methods: {
    async fetch(page) {
      const { data: response } = await this.$helpers.load(
        axios.get("/api/roles", {
          params: {
            page,
            type: this.filterType,
            "order[title]": "asc",
            with: ["permissions"]
          }
        })
      );

      this.updatePagination(response);

      this.roles = response.data;
    },
    async open(type) {
      this.filterType = type || "any";

      const [, { data: response }] = await this.$helpers.load([
        this.fetch(1),
        axios.get(`/api/users/${this.user.id}/roles`)
      ]);

      this.checked = _.map(response.data, role => {
        return { id: role.id };
      });

      this.show();
    },
    close() {
      this.hide();
    },
    save() {
      this.$helpers
        .load(
          axios.put(`/api/users/${this.user.id}/roles`, {
            roles: this.checked
          })
        )
        .then(response => {
          this.$emit("saved", response.data);
        })
        .catch(error => {
          this.$emit("error", error);
        });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/modals/roles/Assignment.vue